import { objectToParam } from "../../libs/utils";
import axios from "../api";

export async function getRegistrations(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`/registrations?${parameters}`);
  return data;
}

export async function getRegistration(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`/registrations/${id}?${parameters}`);
  return data;
}

export async function createRegistration(values) {
  const { data } = await axios.post(`/registrations`, values);
  return data;
}

export async function updateRegistration(id, values) {
  const { data } = await axios.put(`/registrations/${id}`, values);
  return data;
}

export async function sendCrewQuantityRequest(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/actions/send-crew-quantity-request`,
    values
  );
  return data;
}

export async function submitCrewQuantityForApproval(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/actions/submit-crew-quantity-for-approval`,
    values
  );
  return data;
}

export async function approveCrewQuantity(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/actions/approve-crew-quantity`,
    values
  );
  return data;
}

export async function rejectCrewQuantity(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/actions/reject-crew-quantity`,
    values
  );
  return data;
}

export async function newUserCrewMember(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/new-user-crew-member`,
    values
  );
  return data;
}

export async function uploadTemplate(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/import-users/upload-template`,
    values
  );
  return data;
}

export async function resetRegenerateVouchersState(id) {
  const { data } = await axios.post(
    `/registrations/${id}/actions/reset-generate-vouchers-state`
  );
  return data;
}

export async function uploadRegistrations(eventId, values) {
  const { data } = await axios.post(
    `/events/${eventId}/import-users/upload-template`,
    values
  );
  return data;
}

export async function syncRegistrationProfiles(id, values) {
  const { data } = await axios.put(`/registrations/${id}/profiles`, values);
  return data;
}

export async function syncRegistrationParkings(id, values) {
  const { data } = await axios.put(`/registrations/${id}/parkings`, values);
  return data;
}

export async function syncRegistrationDepartments(id, values) {
  const { data } = await axios.put(`/registrations/${id}/departments`, values);
  return data;
}

export async function syncRegistrationMaterialCategories(id, values) {
  const { data } = await axios.put(
    `/registrations/${id}/material-categories`,
    values
  );
  return data;
}

export async function syncRegistrationCrewMaterialTemplates(id, values) {
  const { data } = await axios.put(
    `/registrations/${id}/crew-member-material-templates`,
    values
  );
  return data;
}

export async function deleteRegistration(id) {
  const { data } = await axios.delete(`/registrations/${id}`);
  return data;
}

export async function updateRegistrationProfile(
  registrationId,
  regProfileId,
  values
) {
  const { data } = await axios.put(
    `registrations/${registrationId}/profiles/${regProfileId}`,
    values
  );
  return data;
}

export async function getRegistrationCateringOptions(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${id}/catering-options?${parameters}`
  );
  return data;
}

export async function createRegistrationCateringOption(id, values) {
  const { data } = await axios.post(
    `/registrations/${id}/catering-options`,
    values
  );
  return data;
}

export async function getRegistrationAvailableCateringOptions(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${id}/available-catering-options?${parameters}`
  );
  return data;
}

export async function updateRegistrationAllowedCateringOption(id, values) {
  const { data } = await axios.put(
    `/registrations/${id}/allowed-catering-options`,
    values
  );
  return data;
}

export async function getRegistrationSafetyQuestions(registrationId) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/safety-questions?page[size]=50`
  );
  return data;
}

export async function getRegistrationSafetyQuestionAnswers(registrationId) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/safety-question-answers?page[size]=50`
  );
  return data;
}

export async function createRegistrationSafetyQuestionAnswers(
  registrationId,
  values
) {
  console.debug('createRegistrationSafetyQuestionAnswers');
  const formData = new FormData();
  Object.entries(values).forEach(([key, value]) => {
    if (value instanceof FileList) {
      formData.append(key, value[0]);
    } else {
      formData.append(key, value);
    }
  });

  const { data } = await axios.post(
    `/registrations/${registrationId}/safety-question-answers`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}
export async function sendVouchers(registrationId, values) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/send-vouchers`,
    values
  );
  return data;
}

export async function generateCateringInvoice(registrationId) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/actions/generate-catering-invoice`
  );
  return data;
}

export async function generateAllCateringInvoices(eventId) {
  const { data } = await axios.post(
    `/events/${eventId}/actions/generate-catering-invoices`
  );
  return data;
}

export async function updateRegistrationSafetyQuestionAnswers(
  registrationId,
  registrationSafetyQuestionAnswerId,
  values
) {
  const { data } = await axios.put(
    `/registrations/${registrationId}/safety-question-answers/${registrationSafetyQuestionAnswerId}`,
    values
  );
  return data;
}

export async function generateVouchers(registrationId, values) {
  const { data } = await axios.post(
    `registrations/${registrationId}/actions/generate-vouchers`,
    values
  );
  return data;
}
